<template>
    <component :is="mediaQueryComponent" :facets="facets" v-bind="$attrs">
        <template v-for="(slot) in slots">
            <slot :name="getSlotName(slot)" :slot="slot">
                {{ getSlotName(slot) }}
            </slot>
        </template>
    </component>
</template>

<script>
    import { mapState } from 'vuex';
    import { reduce } from 'lodash';

    import { mq as isMq } from 'util/dom/mq';

    export default {
        props: {
            defaultComponent: {
                type: String,
                required: true,
            },

            facets: {
                type: Array,
                default: () => [],
            },

            components: {
                type: Object,
                default: () => {
                },
            },

            /** @type {string[]} */
            slots: {
                type: Array,
                default: () => null,
            },
        },

        data() {
            return {
                mediaQueryComponent: null,
            };
        },

        computed: {
            ...mapState('viewport', ['mq']),
        },

        methods: {
            getSlotName(slot) {
                return `morph-${ slot }`;
            },
        },

        watch: {
            mq() {
                this.mediaQueryComponent = reduce(this.components, (acc, comp, query) => {
                    if (isMq(query) === true) {
                        acc = comp;
                    }
                    return acc;
                }, this.defaultComponent);
            },
        },

        mounted() {
            this.mediaQueryComponent = this.defaultComponent;
        },
    };
</script>
